module.exports = __webpack_public_path__ + "static/inclusive-workplace-desktop.63806cd8.webp";